import { HttpResponse } from "@angular/common/http";

function resolveFilename(
  contentDisposition: string | null,
  fallbackFilename: string
): string {
  if (!contentDisposition) {
    return fallbackFilename;
  }

  const match = new RegExp(/filename\*=UTF-8''(.+)|filename="(.+)"|filename=([^;]+)/).exec(contentDisposition);

  if (!match) {
    return fallbackFilename;
  }

  return decodeURIComponent(match[1] || match[2] || match[3]).trim();
}

export function downloadFileFromResponse(
  response: HttpResponse<Blob>,
  fallbackFilename: string
): void {
  if (!response.body) {
    return;
  }

  const url = window.URL.createObjectURL(response.body);
  const filename = resolveFilename(
    response.headers.get("Content-Disposition"),
    fallbackFilename
  );
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.download = filename;
  anchor.click();

  window.URL.revokeObjectURL(url);
}